import styled from "styled-components"
import { maxWidth, maxHeight, noTouch } from '@/assets/styles/mixins.css.js'
import vars from '@/assets/styles/vars'
import Button from "../styles/StyledButton"

const Container = styled.div`
  z-index: 2;
  padding: 48px;
  background: #fff;
  width: 100%;
  ${maxWidth(vars.breakpoints.tablet)`
    padding: 30px;
  `}
  ${maxWidth(vars.breakpoints.mobile)`
    padding: 20px;
  `}
`

const Link = styled.a`
  text-decoration: none;
  color: #1B48B1;
  margin-left: 0.3em;
  cursor: pointer;
`

const Title = styled.h4`
  font-size: 20px;
  font-weight: bold;
  color: #192043;
  margin-bottom: 20px;
  ${maxWidth(vars.breakpoints.tablet)`
    font-size: 18px;
    margin-bottom: 18px;
  `}
    ${maxWidth(vars.breakpoints.lMobile)`
    font-size: 14px;
    margin-bottom: 18px;
  `}
`

const SubTitle = styled.h6`
  font-size: 18px;
  font-weight: bold;
  color: #192043;
`

const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: ${props => props.gap ? props.gap + 'px' : 0};
`

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${props => props.justifyContent ?? 'flex-start'};
  gap: ${props => props.gap ? props.gap + 'px' : 0};
`

const Line = styled.div`
  display: grid;
  grid-template-columns: 1fr 200px;
  gap: 1em;
  align-items: center;
  justify-content: ${props => props.justifyContent ?? 'flex-start'};
  ${maxWidth(vars.breakpoints.tablet)`
    grid-template-columns: 1fr 100px;
  `}
  ${maxWidth(vars.breakpoints.lMobile)`
    grid-template-columns: 1fr;
  `}
`

const ToggleButtonWrapper = styled.div`
  cursor: pointer;
  height: 24px;
  width: 80px;
  position: relative;
  border-radius: 15px;
  border-width: 2px;
  border-style: solid;
  box-sizing: border-box;
  margin: 0 auto;
  background: ${props => props.isActive ? 'rgba(182, 155, 100, 0.5)' : 'rgba(191, 191, 191, 0.5)'};
  transition: all 200ms ease;
  &:after {
    content: "";
    position: absolute;
    z-index: 5;
    left: ${props => props.isActive ? 'calc(100% - 27px)' : '-1px'};
    top: -4px;
    width: 28px;
    height: 28px;
    border-radius: 14px;
    background-color: ${props => props.isActive ? 'rgba(182, 155, 100, 1)' : 'rgba(191, 191, 191, 1)'};
    transition: all 200ms ease;
  }
`

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  width: 100%;
`

const TopButtons = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 40px;
  gap: 20px;

  ${Button} {
    width:100%;
  }

  @media screen and (max-width: 900px) {
    display: flex;
    flex-direction: column;
    gap: 0;
    button:not(:last-child) {
      margin-bottom: 20px;
    }
  }
`

const Text = styled.p`
  color: #4E546C;
  font-size: 14px;
  line-height: 1.6;
  font-weight: normal;
  ${maxWidth(vars.breakpoints.lMobile)`
    font-size: 13px;
  `}
`

export const Cookie = {
  Container,
  Title,
  SubTitle,
  FlexCol,
  FlexRow,
  Line,
  ToggleButtonWrapper,
  Text,
  ButtonsWrapper,
  TopButtons,
  Link
}